export default __webpack_public_path__ + "static/media/wave_glitch.1daf38e3.png";